export default __webpack_public_path__ + "static/media/icons8-share-rounded-96.7daebc4c.svg";